import { StatusModal } from '@cian/frontend-e2e-deal-component';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ETestIds } from 'shared/constants/testIds';
import { useApplicationStatusModal } from 'shared/hooks/useApplicationStatusModal';
import { selectCalculatorValues, selectOffersForAnalytic } from 'shared/selectors/landing';
import { formatCallSlotTitle, mapApplicationToSummaryCard } from 'shared/utils/mappers';
import { useTracking } from 'shared/utils/tracking/useTracking';

import {
  APPLICATION_STATUS_MODAL_SUBTITLE_WITHOUT_PHONE,
  APPLICATION_STATUS_MODAL_SUBTITLE_WITH_PHONE,
  APPLICATION_STATUS_MODAL_WARNING,
} from './constants';

export const ApplicationStatusModalContainer: React.FC = () => {
  const { isModalOpen, application, place, handleModalClose } = useApplicationStatusModal();
  const calculatorValues = useSelector(selectCalculatorValues);
  const offers = useSelector(selectOffersForAnalytic);
  const { trackShowApplicationStatusModal } = useTracking();

  const offer = place === null ? null : (offers?.[place] ?? null);

  useEffect(() => {
    if (isModalOpen) {
      trackShowApplicationStatusModal(offer, calculatorValues);
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [isModalOpen]);

  /** Слот у отправленной заявки есть всегда по контракту бэка, и заголовок собирается только из
      него: без слота показывать модалку нечем, поэтому выходим, а не подставляем чужой текст. */
  if (!isModalOpen || !application?.callSlot) {
    return null;
  }

  const { callSlot, contact, offers: applicationOffers, searchParams } = application;
  const phone = contact?.phone ?? '';

  return (
    <StatusModal
      open={isModalOpen}
      onClose={handleModalClose}
      title={
        /* testId внутри модалки: контент уходит в портал, внешняя обёртка была бы пустым div */
        <span data-testid={ETestIds.ApplicationStatusModal}>{formatCallSlotTitle({ callSlot })}</span>
      }
      subtitle={
        phone
          ? `${APPLICATION_STATUS_MODAL_SUBTITLE_WITH_PHONE} ${phone}`
          : APPLICATION_STATUS_MODAL_SUBTITLE_WITHOUT_PHONE
      }
      creditSummary={mapApplicationToSummaryCard({ offers: applicationOffers, searchParams })}
      clientContacts={{ name: contact?.fullName ?? '', phone, email: contact?.email ?? '' }}
      warning={APPLICATION_STATUS_MODAL_WARNING}
    />
  );
};
